import * as React from "react";
import SearchContainer from "./SearchContainer";
import ResultsContainer from "./ResultsContainer";


export default function App() {

    return (
        <div className="performance-search">
            <SearchContainer />
            <ResultsContainer />
        </div>
    );
}



